import React, { useEffect } from 'react';
import CustomHead from '@/components/Common/Layout/Head';
import SimplePricing from '@/components/Pricing/SimplePricing';
import { Layout } from '@/components/Common';
import { NextPageWithLayout } from '@/pages/_app';
import { SEO_META } from '@/shared/seo';
import { SEO_META_PAGES } from '@/shared/types/seo';
import { WEBSITE_URL } from '@/shared/constants';
import { logCommonView, logPageView } from '@/lib/service';
import { EventSource } from '@/shared/constants/event';
import { useStoreModuleItemsQuery, SortDirection, StoreModuleItemSortFields } from '@/lib/service/pietra-v2';

const PlansAndPricing = ({}: NextPageWithLayout<any>) => {
  const { data } = useStoreModuleItemsQuery({
    variables: {
      filter: { isEnabled: { is: true } },
      sorting: { direction: SortDirection.Desc, field: StoreModuleItemSortFields.CreatedAt },
      paging: { offset: 0, limit: 50 },
    },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    logPageView({
      pageUrl: window.location.href || '',
      routeName: window.location.pathname,
      pageTitle: 'Plans & Pricing | Pietra',
    });
    logCommonView(EventSource.PRICING, 'VIEW');
  }, []);
  return <SimplePricing storeModuleItems={data?.list?.nodes ?? []} />;
};

PlansAndPricing.getLayout = (page: React.ReactElement) => {
  const invisibleHeaderTags = (
    <div style={{ display: 'none' }}>
      <h1>Pietra Pricing - Setup and Open Your Online Store Today</h1>
      <h2>Pietra has a plan for every creator.</h2>
      <h2>Pietra - The smartest way to start your e-commerce business.</h2>
      <h2>Pietra With Priority Support - The smartest way to start and scale your e-commerce business.</h2>
      <h2>Pietra Premium - For scaling brands shipping 2000+ units per month</h2>
    </div>
  );

  return (
    <>
      <CustomHead
        title="Plans & Pricing | Pietra"
        description="All in one membership for e-commerce brands to lower costs and grow your business."
        url={`${WEBSITE_URL}/plans-and-pricing`}
      />
      <Layout
        structured={SEO_META[SEO_META_PAGES.PRICING].jsonld({
          url: typeof window === 'object' ? window.location.href : '',
        })}
      >
        {invisibleHeaderTags}
        {page}
      </Layout>
    </>
  );
};

export default PlansAndPricing;
